import { Link, Text } from '@nimbus-ds/components';
import { differenceInDays } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useNavegate } from 'App/hooks';
import { usePlanDowngrade } from 'domains/Billing/BillingPlans/hooks';
import { BILLING_ROUTES } from 'domains/Billing/billingRoutes';
import { AdBar } from './AdBar';

export default function DowngradeAdBar() {
  const { scheduledDowngrade } = usePlanDowngrade(true, false);
  const { t } = useTranslation('common');
  const { goTo } = useNavegate();

  if (!scheduledDowngrade?.scheduledAt) return null;

  const remainingDaysToDowngrade = differenceInDays(
    new Date(scheduledDowngrade.scheduledAt),
    new Date().setHours(0, 0, 0, 0),
  );

  if (remainingDaysToDowngrade <= 0 || remainingDaysToDowngrade > 5)
    return null;

  const handleClick = () => {
    goTo(BILLING_ROUTES.plans);
  };

  return (
    <AdBar appearence="warning">
      <Text color="warning-textLow" fontWeight="bold">
        {t('topAdBar.billingDowngrade.text', {
          daysUntil: remainingDaysToDowngrade,
        })}
      </Text>
      <Link onClick={handleClick} appearance="primary" textDecoration="none">
        {t('topAdBar.billingDowngrade.link')}
      </Link>
    </AdBar>
  );
}
